import * as tslib_1 from "tslib";
import CultureSelection from './CultureSelection';
import DateFormatSelection from './DateFormatSelection';
import TimeFormatSelection from './TimeFormatSelection';
import TimeZoneSelection from './TimeZoneSelection';
import { observer } from 'mobx-react';
import * as React from 'react';
var RegionalFull = /** @class */ (function (_super) {
    tslib_1.__extends(RegionalFull, _super);
    function RegionalFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RegionalFull.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(CultureSelection, null),
            React.createElement(DateFormatSelection, { showExampleWithDateFormatLabel: true }),
            React.createElement(TimeFormatSelection, null),
            React.createElement(TimeZoneSelection, null)));
    };
    RegionalFull = tslib_1.__decorate([
        observer
    ], RegionalFull);
    return RegionalFull;
}(React.Component));
export default RegionalFull;
//# sourceMappingURL=RegionalFull.js.map